import React, { useState, useEffect } from "react";
import Menu from "../menu/Menu";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../BaseURL/BaseURL";
import { trackPurchase } from "../../lib/fbPixel";

function CheckOut() {
  const navigate = useNavigate();
  const id = JSON.parse(localStorage.getItem("checkoutProductIds")); // Parse the JSON array of product IDs
  // Read the computed total (including delivery) stored by ViewCart
  const storedSubtotal = localStorage.getItem("subtotal");
  const subtotalValue = storedSubtotal ? Number(storedSubtotal) : null;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneno: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    subtotal: subtotalValue,
    products: id, // Directly set the product IDs obtained from localStorage
    titles: id?.map((productId) => ({ product_id: productId })),
  });
  const [showModal, setShowModal] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [loadingConfirm, setLoadingConfirm] = useState(false);

  useEffect(() => {
    // Retrieve token from localStorage and set it in the Axios headers
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    // Fetch product titles
    console.log("CheckOut mounted. token present:", !!token);
    // Load cart items for order summary (authenticated or guest)
    const loadCartItems = async () => {
      try {
        if (token) {
          const resp = await axios.get(`${baseurl}/get-cart`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setCartItems(resp.data.data || []);
        } else {
          const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
          setCartItems(guestCart);
        }
      } catch (err) {
        console.error("Error loading cart items:", err);
      }
    };

    loadCartItems();
  }, []);

  // const fetchProductTitles = async (productIds) => {
  //   try {
  //     console.log("Product IDs:", productIds); // Log the product IDs to check if they are valid
  //     const titles = [];
  //     for (const productId of productIds) {
  //       const response = await axios.get(
  //         `https://mr-book-066682c9409f.herokuapp.com/userinformation-get/${productId}`
  //       );
  //       titles.push(response.data.title);
  //       console.log("Title:", response.data.title); // Log the title of each product
  //     }
  //     setFormData((prevData) => ({ ...prevData, titles }));
  //   } catch (error) {
  //     console.error("Error fetching product titles:", error);
  //   }
  // };

  // When main form is submitted, show modal for confirmation (do not call API yet)
  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  // Confirm order: call APIs similarly to previous implementation
  const confirmOrder = async () => {
    setLoadingConfirm(true);
    try {
      const token = localStorage.getItem("token");

      const data = {
        name: formData.name,
        email: formData.email,
        phoneno: formData.phoneno,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zipcode: formData.postalCode,
        subtotal: formData.subtotal,
      };

      if (token) {
        // Build products payload based on cartItems
        const productsPayload = (cartItems || []).map((it) => ({
          product_id: it.product_id?._id || it.productId,
          quantity: it.cartQuantity || it.quantity || 1,
          subtotal:
            it.subtotal ||
            (it.price ? it.price * (it.cartQuantity || it.quantity || 1) : 0),
        }));

        const response = await axios.post(
          `${baseurl}/userinformation`,
          { ...data, products: productsPayload },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.status === 200) {
          // Track Purchase for authenticated user
          try {
            const productIds = productsPayload.map((p) => p.product_id);
            trackPurchase({
              content_ids: productIds,
              content_type: "product",
              num_items: productIds.length,
              value: data.subtotal,
              currency: "PKR",
            });
          } catch (e) {
            console.error("Failed to track Purchase", e);
          }
          // Empty the cart on backend
          await axios.delete(`${baseurl}/empty-cart`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          localStorage.setItem("name", formData.name);
          localStorage.setItem("email", formData.email);
          localStorage.removeItem("checkoutProductIds");
          setShowModal(false);
          alert("Book has been ordered");
          navigate("/");
        } else {
          alert("Error submitting form. Please try again.");
        }
      } else {
        // Guest flow
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
        const productsPayload = guestCart.length
          ? guestCart.map((it) => ({
              product_id: it.productId,
              quantity: it.quantity,
              subtotal: it.subtotal,
            }))
          : (cartItems || []).map((it) => ({
              product_id: it.product_id?._id || it.productId,
              quantity: it.quantity || 1,
              subtotal: it.subtotal,
            }));

        const response = await axios.post(`${baseurl}/userinformation-guest`, {
          ...data,
          products: productsPayload,
        });
        if (response.status === 200) {
          // Track Purchase for guest orders
          try {
            const productIds = productsPayload.map((p) => p.product_id);
            trackPurchase({
              content_ids: productIds,
              content_type: "product",
              num_items: productIds.length,
              value: data.subtotal,
              currency: "PKR",
            });
          } catch (e) {
            console.error("Failed to track Purchase (guest)", e);
          }
          localStorage.setItem("name", formData.name);
          localStorage.setItem("email", formData.email);
          // Clear guest cart data
          localStorage.removeItem("guestCart");
          localStorage.removeItem("checkoutProductIds");
          localStorage.removeItem("subtotal");
          setShowModal(false);
          alert("Book has been ordered");
          navigate("/");
        } else {
          alert("Error submitting guest order. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setLoadingConfirm(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <>
      <Menu />
      <h1 className="text-xl md:text-4xl font-bold px-4 flex justify-center items-center font-serif">
        CheckOut
      </h1>
      <form onSubmit={handleSubmit}>
        <div className="px-10 pt-5 w-full ">
          <h1 className="text-2xl font-bold font-serif">User Information</h1>
          <div className="w-full md:w-[50%] pt-8 flex flex-col gap-y-4 md:gap-y-7">
            <div className="w-full flex gap-x-3">
              <input
                type="text"
                required
                placeholder="Name"
                className="rounded-xl w-full py-2 px-5 border border-gray-500"
                name="name"
                onChange={handleChange}
              />
              <input
                type="text"
                required
                placeholder="Email"
                className="rounded-xl w-full px-3 border border-gray-500 py-2"
                name="email"
                onChange={handleChange}
              />
            </div>
            <div className="w-full flex gap-x-3">
              <input
                type="number"
                placeholder="phone No."
                className="rounded-xl w-full py-2 px-5 border border-gray-500"
                required
                name="phoneno"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="w-full md:w-[50%] pt-5 flex flex-col gap-y-4 md:gap-y-7">
            <h1 className="font-bold text-2xl font-serif">Shipping Address</h1>
            <input
              type="text"
              required
              placeholder="Address"
              className="w-full rounded-xl border border-gray-500 py-2 px-3"
              name="address"
              onChange={handleChange}
            />
            <div className="w-full flex gap-x-3">
              <input
                type="text"
                required
                placeholder="City"
                className="rounded-xl w-full py-2 px-5 border border-gray-500"
                name="city"
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Province"
                className="rounded-xl w-full px-3 border border-gray-500 py-2"
                required
                name="state"
                onChange={handleChange}
              />
            </div>
            <div className="w-full flex gap-x-3">
              <input
                type="text"
                placeholder="Postal/Zip code"
                className="rounded-xl w-full py-2 px-5 border border-gray-500"
                required
                name="postalCode"
                onChange={handleChange}
              />
            </div>
            <div className="w-full gap-y-3 flex flex-col mb-5">
              <div className="w-full bg-yellow-500 items-center text-center rounded-2xl">
                <h1 className="text-2xl font-bold p-2">Cash On Delivery</h1>
              </div>
              <button
                type="submit"
                className="py-2 w-full bg-yellow-500 hover:bg-yellow-700 text-black font-serif font-bold rounded-full"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </form>
      {/* Confirmation modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black opacity-50"
            onClick={() => setShowModal(false)}
          />
          <div className="relative bg-white rounded-lg shadow-lg w-11/12 md:w-2/3 lg:w-1/2 z-60 p-6">
            <h2 className="text-2xl font-bold mb-4">Confirm Your Order</h2>
            <div className="mb-4">
              <h3 className="font-semibold mb-2">Customer Details</h3>
              <div className="border p-3 rounded mb-3">
                <div className="text-sm text-gray-700"><span className="font-semibold">Name: </span>{formData.name || "-"}</div>
                <div className="text-sm text-gray-700"><span className="font-semibold">Email: </span>{formData.email || "-"}</div>
                <div className="text-sm text-gray-700"><span className="font-semibold">Phone: </span>{formData.phoneno || "-"}</div>
                <div className="text-sm text-gray-700"><span className="font-semibold">Address: </span>{formData.address || "-"}</div>
              </div>
            </div>

            <div className="max-h-64 overflow-y-auto border p-3 rounded mb-4">
              {cartItems && cartItems.length ? (
                cartItems.map((item, idx) => (
                  <div
                    key={idx}
                    className="flex items-center gap-x-4 py-2 border-b last:border-b-0"
                  >
                    {item.url && (
                      <img
                        src={item.url}
                        alt={item.title || "product"}
                        className="w-16 h-16 object-cover rounded"
                      />
                    )}
                    <div className="flex-1">
                      <div className="font-semibold">
                        {item.title || item.product_id?.title || "Product"}
                      </div>
                      <div className="text-sm text-gray-600">
                        Qty: {item.cartQuantity || item.quantity || 1}
                      </div>
                    </div>
                    <div className="font-semibold">
                      {item.subtotal ??
                        (item.price
                          ? item.price *
                            (item.cartQuantity || item.quantity || 1)
                          : "-")}{" "}
                      Rs
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-600">
                  No products found
                </div>
              )}
            </div>
            <div className="flex justify-between font-semibold mb-2">
              <div>Subtotal</div>
              <div>
                {(() => {
                  const base = (cartItems || []).reduce(
                    (s, it) =>
                      s +
                      (it.subtotal ||
                        (it.price
                          ? it.price * (it.cartQuantity || it.quantity || 1)
                          : 0)),
                    0
                  );
                  return `${base} Rs`;
                })()}
              </div>
            </div>
            <div className="flex justify-between font-semibold mb-4">
              <div>Delivery</div>
              <div>
                {(() => {
                  const base = (cartItems || []).reduce(
                    (s, it) =>
                      s +
                      (it.subtotal ||
                        (it.price
                          ? it.price * (it.cartQuantity || it.quantity || 1)
                          : 0)),
                    0
                  );
                  return base >= 3000 ? `Free` : `Rs 200`;
                })()}
              </div>
            </div>
            <div className="flex justify-between font-bold text-lg mb-4">
              <div>Total</div>
              <div>
                {(() => {
                  const base = (cartItems || []).reduce(
                    (s, it) =>
                      s +
                      (it.subtotal ||
                        (it.price
                          ? it.price * (it.cartQuantity || it.quantity || 1)
                          : 0)),
                    0
                  );
                  const delivery = base >= 3000 ? 0 : 200;
                  return `${base + delivery} Rs`;
                })()}
              </div>
            </div>
            <div className="flex gap-x-3 justify-end">
              <button
                className="px-4 py-2 rounded bg-gray-200"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded bg-yellow-500 text-black font-semibold"
                onClick={confirmOrder}
                disabled={loadingConfirm}
              >
                {loadingConfirm ? "Processing..." : "Confirm Order"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CheckOut;
